import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-largecta {
      padding: 80px 40px !important;
    }
  }
  .ck-largecta div a {
    margin-top: 16px !important;
  }
`

export function LargeCTA({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderWidth: properties.borderWidth,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    backgroundImage: `url(${properties.image})`,
    backgroundSize: "cover",
    paddingTop: 155,
    paddingRight: 75,
    paddingBottom: 155,
    paddingLeft: 75
  }

  return (
    <div
      className="ck-largecta ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width="100%"
              style={{
                verticalAlign: "middle",
                backgroundColor:
                  properties.contentBackgroundColor === undefined
                    ? "#FFFFFF"
                    : properties.contentBackgroundColor,
                paddingTop: properties.verticalPadding,
                paddingRight: properties.horizontalPadding,
                paddingBottom: properties.verticalPadding,
                paddingLeft: properties.horizontalPadding,
                borderTopLeftRadius: properties.borderTopLeftRadius,
                borderTopRightRadius: properties.borderTopRightRadius,
                borderBottomLeftRadius: properties.borderBottomLeftRadius,
                borderBottomRightRadius: properties.borderBottomRightRadius
              }}
            >
              <LiteSlateEditor block_id={children[0].block_id} />
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
